const DiscordIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 42 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.829 2.51249C30.3203 1.33875 27.638 0.485722 24.8336 0C24.4892 0.622678 24.0868 1.46019 23.8094 2.12643C20.8283 1.67811 17.8746 1.67811 14.9483 2.12643C14.6709 1.46019 14.2594 0.622678 13.9119 0C11.1046 0.485722 8.41909 1.34188 5.91042 2.51871C0.850414 10.165 -0.52127 17.6215 0.164573 24.972C3.52064 27.4782 6.77306 29.0007 9.9706 29.9969C10.7601 28.9104 11.4642 27.7553 12.0708 26.538C10.9155 26.099 9.80905 25.5573 8.76355 24.9284C9.04092 24.7229 9.31223 24.5081 9.57434 24.287C15.9511 27.2696 22.8797 27.2696 29.1803 24.287C29.4455 24.5081 29.7168 24.7229 29.9911 24.9284C28.9425 25.5604 27.833 26.1021 26.6778 26.5411C27.2844 27.7553 27.9854 28.9135 28.778 30C31.9786 29.0037 35.234 27.4813 38.5901 24.972C39.3948 16.4508 37.2154 9.06291 32.829 2.51249ZM12.9395 20.4515C11.0253 20.4515 9.45545 18.6644 9.45545 16.4882C9.45545 14.312 10.9918 12.5218 12.9395 12.5218C14.8874 12.5218 16.4572 14.3088 16.4236 16.4882C16.4267 18.6644 14.8874 20.4515 12.9395 20.4515ZM25.8151 20.4515C23.9009 20.4515 22.331 18.6644 22.331 16.4882C22.331 14.312 23.8673 12.5218 25.8151 12.5218C27.7629 12.5218 29.3327 14.3088 29.2992 16.4882C29.2992 18.6644 27.7629 20.4515 25.8151 20.4515Z"
        fill="white"
      />
    </svg>
  );
};

export default DiscordIcon;
